import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';

import BadgeActive from 'src/components/Badge/BadgeActive';
import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import UUID from 'src/components/UUID';
import getFullAddressString from 'src/util/address';
import { getNodesFromEdges } from 'src/util/graphql';

/**
 * Description
 * @param {object} props
 * @param {object} props.property
 * @returns {React.ReactComponentElement} - AdminCommunityShowProperty component
 */
function AdminCommunityShowProperty({ property = null }) {
  if (!property) {
    return null;
  }

  const {
    uuid, title, externalIdentifier, active, address, primaryBillingPoints,
  } = property;

  const primaryBillingPointsNodes = primaryBillingPoints?.edges
    ? getNodesFromEdges(primaryBillingPoints)
    : [];
  const addr = getFullAddressString(address);

  return (
    <tr key={`property-${uuid}`}>
      <th scope="row">
        <Link to={`/admin/properties/${uuid}`}>
          {title}
        </Link>
        {addr && (
          <>
            <br />
            {addr}
          </>
        )}
      </th>
      <td>
        <UUID uuid={uuid} />
      </td>
      <td>
        {externalIdentifier}
      </td>
      <td>
        {primaryBillingPointsNodes.length > 0 && (
        <ul className="ps-2">
          {primaryBillingPointsNodes.map((node) => (
            <li key={node.uuid}>
              <Link to={`/admin/primary-billing-points/${node.uuid}`}>
                {node.identifier}
              </Link>
              <br />
              <UUID uuid={node.uuid} />
              <br />
              <BadgeActive
                start={node.active?.start}
                finish={node.active?.finish}
              />
            </li>
          ))}
        </ul>
        )}
      </td>
      <td>
        <BadgeActiveTimeRange active={active} />
      </td>
    </tr>
  );
}

AdminCommunityShowProperty.propTypes = {
  property: PropTypes.shape({
    uuid: PropTypes.string,
    externalIdentifier: PropTypes.string,
    title: PropTypes.string,
    active: PropTypes.shape({
      start: PropTypes.number,
      finish: PropTypes.number,
    }),
    address: PropTypes.shape({
      line1: PropTypes.string,
      line2: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      postcode: PropTypes.string,
    }),
    primaryBillingPoints: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.shape({
        node: PropTypes.shape({
          uuid: PropTypes.string.isRequired,
          identifier: PropTypes.string.isRequired,
          active: PropTypes.shape({
            start: PropTypes.number,
            finish: PropTypes.number,
          }),
        }),
      })),
    }),
  }),
};

export default AdminCommunityShowProperty;
